import { useInfiniteQuery } from 'react-query';
import request from '@/utils/request';
import { objectToParams } from '@/utils/url';

const defaultSearch = {
  limit: 12,
  offset: 0,
  publications: ['b2c'],
  context: 'onboarding',
  types: 'seekube',
}

export function useInfiniteGetEvents(
  {
    eventsId = [],
    search = defaultSearch,
    context = 'exponent'
  }) {

  const queryFn = (pageParams) => {
    const { pageParam: page } = pageParams;
    const searchParams = objectToParams({ ...search, page, offset: page * search.limit });

    const requestUrl = `${process.env.FRONT_API_URL}/events?${searchParams}&context=${context}&eventsId=${encodeURIComponent(eventsId.join(','))}`;

    return request(requestUrl,
      { method: 'GET' });
  };

  const query = useInfiniteQuery({
    queryKey: ['events'],
    keepPreviousData: true,
    cacheTime: 10000,
    getNextPageParam: (lastPage, pages) => {
      if ((lastPage.offset +  lastPage.limit) <= lastPage.total) {
        return ((lastPage.offset / lastPage.limit) + 1);
      }
    },
    select: (data) => ({
        pages: [...data.pages],
        pageParams: [...data.pageParams],
        total: data?.pages?.[0]?.total,
      }),
    queryFn,
    refetchOnWindowFocus: false,
  });

  return query;
}
